module.exports = __webpack_public_path__ + "static/img/video-1.99b3920.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video/video-1.jpg
// module id = OspG
// module chunks = 12